import { render, staticRenderFns } from "./ForumActivoBannerSettingsTab.vue?vue&type=template&id=c29cbf4e&scoped=true&"
import script from "./ForumActivoBannerSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ForumActivoBannerSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./ForumActivoBannerSettingsTab.vue?vue&type=style&index=0&id=c29cbf4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29cbf4e",
  null
  
)

export default component.exports